import { IconButton, Tooltip } from "@mui/material";
import React, { useRef, forwardRef } from "react";
import postRibbon from "../../../../../Assets/statusRibbon/post.png";
import Draft from "../../../../../Assets/statusRibbon/draft.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { useReactToPrint } from "../../../../Shared/print/useHtml2PdfPrint";
import ReactToPrint from "../../../../Shared/print/ReactToPrint";
import { convertDateFormat, today } from "../../../../../Js/Date";
import { vendorBillSingleViewApi } from "../API/vendorBillAPI";
import { getTemplateAPI } from "../../../SalesNew/SalesOrders/SalesQuotation/salesQuatationAPI";
import Template1 from "../../../SalesNew/SalesOrders/SalesQuotation/Template1";
import Template2 from "../../../SalesNew/SalesOrders/SalesQuotation/Template2";
import { set_Back_button_action } from "../../../../Single Components/listSlice/filterCategorySlice";
// import { InvoiceContent } from "../../PrintComponents/printTemplates/common/InvoiceContent";
// import { printSection } from "../../PrintComponents/printTemplates/common/enum";

// Simple standalone print component for Vendor Bill
const VendorBillPrintContent = forwardRef((props, ref) => {
  const { formValues, data, tax, dates } = props;
  const decimalPosition = localStorage.getItem("decimalPosition") || 2;

  return (
    <div ref={ref} style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h1 style={{ margin: '0', fontSize: '24px' }}>Vendor Bill</h1>
        <p style={{ margin: '5px 0', fontSize: '18px', fontWeight: 'bold' }}>{formValues?.name}</p>
      </div>

      {/* Company and Vendor Info */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
        <div style={{ width: '45%' }}>
          <h3 style={{ margin: '0 0 10px 0', fontSize: '14px' }}>From:</h3>
          <p style={{ margin: '5px 0', fontSize: '12px' }}>{formValues?.companyName}</p>
          <p style={{ margin: '5px 0', fontSize: '12px' }}>{formValues?.companyAddress}</p>
          <p style={{ margin: '5px 0', fontSize: '12px' }}>{formValues?.companyContact}</p>
          {formValues?.companyTRN && <p style={{ margin: '5px 0', fontSize: '12px' }}>TRN: {formValues?.companyTRN}</p>}
        </div>
        <div style={{ width: '45%', textAlign: 'right' }}>
          <h3 style={{ margin: '0 0 10px 0', fontSize: '14px' }}>Vendor:</h3>
          <p style={{ margin: '5px 0', fontSize: '12px' }}>{formValues?.customerName}</p>
          <p style={{ margin: '5px 0', fontSize: '12px' }}>{formValues?.customerAddress}</p>
          <p style={{ margin: '5px 0', fontSize: '12px' }}>{formValues?.customerContact}</p>
          {formValues?.trn && <p style={{ margin: '5px 0', fontSize: '12px' }}>TRN: {formValues?.trn}</p>}
        </div>
      </div>

      {/* Date */}
      <div style={{ marginBottom: '20px' }}>
        <p style={{ margin: '5px 0', fontSize: '12px' }}>
          <strong>Date:</strong> {formValues?.expiry}
        </p>
      </div>

      {/* Table */}
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
        <thead>
          <tr style={{ backgroundColor: '#eaeef9' }}>
            <th style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px' }}>No</th>
            <th style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px' }}>Product</th>
            <th style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px' }}>Account</th>
            <th style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px' }}>UOM</th>
            <th style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px' }}>QTY</th>
            <th style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px' }}>Unit Price</th>
            <th style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px' }}>Discount</th>
            <th style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px' }}>Tax</th>
            <th style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px' }}>Amount</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <tr key={index}>
              <td style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px' }}>{index + 1}</td>
              <td style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px' }}>{item?.product || item?.label}</td>
              <td style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px' }}>{item?.accountName}</td>
              <td style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px' }}>{item?.purchaseUomName}</td>
              <td style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px', textAlign: 'right' }}>
                {item?.recievedQuantity || item?.qty}
              </td>
              <td style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px', textAlign: 'right' }}>{item?.unitPrice}</td>
              <td style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px', textAlign: 'right' }}>{item?.discount}</td>
              <td style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px' }}>
                {item.taxIdList?.map((r, i) => (
                  <span key={i} style={{ display: 'block', fontSize: '10px' }}>{r?.taxName}</span>
                ))}
              </td>
              <td style={{ border: '1px solid #ddd', padding: '8px', fontSize: '12px', textAlign: 'right' }}>
                {item?.lineTotal?.toFixed(decimalPosition) || item?.subTotal}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Totals */}
      <div style={{ textAlign: 'right', marginBottom: '20px' }}>
        <p style={{ margin: '5px 0', fontSize: '12px' }}>
          <strong>Total:</strong> {formValues?.total || 0}
        </p>
        {dates?.map((date, index) => (
          <p key={index} style={{ margin: '5px 0', fontSize: '12px' }}>
            <strong>{date.name}:</strong> {date.totalAmount}
          </p>
        ))}
        <hr style={{ margin: '10px 0' }} />
        <p style={{ margin: '5px 0', fontSize: '14px', fontWeight: 'bold' }}>
          <strong>Amount Due:</strong> {formValues?.amountDue || 0}
        </p>
      </div>

      {/* Terms and Conditions */}
      {formValues?.termsAndCondition && (
        <div style={{ marginTop: '30px' }}>
          <h3 style={{ margin: '0 0 10px 0', fontSize: '14px' }}>Terms & Conditions</h3>
          <p style={{ margin: '5px 0', fontSize: '12px' }}>{formValues?.termsAndCondition}</p>
        </div>
      )}
    </div>
  );
});

export const VendorBillSingleView = () => {
  let singleViewID = localStorage.getItem("singleViewById");
  const singleViewId = localStorage.getItem("singleVendorById")
  let navigateTo = useNavigate();
  let paymentsPrint = useRef();
  let paymentsPrintNew = useRef();
  const componentRef = useRef();
  const printRef = useRef();

  const[path,setPath] = useState(false);
  const [head,setHead] = useState("")
  const [selectedHeading, setSelectedHeading] = useState("Single View");
  const sequence = localStorage.getItem("sequence")
  const vendorid =localStorage.getItem("singleViewByIdgrn")
  //data of selected List
  const singleList = useSelector((state) => state?.vendorBillSlice?.rowData);
  // company details and info
  const companyProfileData = useSelector(
    (state) => state?.companyProfileSlice?.userValue
  );
  const decimalPosition = localStorage.getItem("decimalPosition");

  const template =useSelector((state)=>state?.salesQuatationSlice?.setTemplate)
  const dispatch = useDispatch();

  const changeColor = (heading) => {
    setSelectedHeading(heading);
  };

  const handleBackpage=()=>{
    localStorage.removeItem("singleViewByIdgrn")
    navigateTo("/userdashboard/purchaseManager/NewPurchaseOrder");
    dispatch(set_Back_button_action({ backButtonClickAction: true }));
  }
  useEffect(() => {
    setHead(sequence);
    const idToUse = singleViewID || singleViewId; // Use singleViewId if singleViewID is undefined
    vendorBillSingleViewApi({ _id: idToUse });

    
  }, [singleViewID, singleViewId]);
  const formValuesInitialState = {
    status: "",
    companyLogo: "",
    companyName: "",
    companyAddress: "",
    companyContact: "",
    companyTRN: "",

    customerName: "",
    customerAddress: "",
    customerContact: "",
    trn:"",

    dateN1:"Return Date",
    dateN2:"Invoice Date",

    termsAndCondition:"",

    expiry:"",
    refN:"PO NO",
    address:"Vendor ",
    lpo:"",
    ref:"",
    sequence:"Bill No",
    name: "",
    firstDate: "",
    secondDate: "",
    amountDue:"",
    subtotal: "",
    total: "",
    totalAmount:"",
    payTerm:"",
    label:"VENDOR BILL"
  };
  const [formValues, setFormValues] = useState(formValuesInitialState);
  const [data, setData] = useState([]);
  const [dates,setDates] =useState([]);
  const [tax, setTax] = useState([]);
  const [domain, setDomain] = useState("");

  // api to fetch companyprofile data
  useEffect(() => {
    getTemplateAPI();
  }, []);

  const handleEdit=()=>{
    localStorage.setItem("singleViewById",singleList?.purchaseId)
    navigateTo("/userdashboard/purchaseManager/CreateNewPurchaseOrder")
  }
  useEffect(() => {
    setFormValues({
      ...formValues,
      status: singleList?.status,
      companyLogo: companyProfileData?.logo || "",
      companyName: companyProfileData?.companyName || "",
      companyAddress: companyProfileData?.companyAddress || "",
      companyContact: companyProfileData?.contactNumber || "",

      customerName: singleList?.vendorAddress?.name || "",
      customerAddress: singleList?.vendorAddress?.email || "",
      customerContact: singleList?.vendorAddress?.mobileNo || "",
      ref: singleList?.billreference || "",

      termsAndCondition:singleList?.termsAndCondition || "",

      
      subtotal: singleList?.subTotal || "",
      lpo: singleList?.LpoNo ||"",
      name: singleList?.name || "",
      expiry: singleList?.billDate || "",
      secondDate: singleList?.dueDate || "",
      totalAmount: singleList?.total || "",
      total: singleList?.total || "",
      payTerm: singleList?.PAYMENTTERM || "",
      amountDue: singleList?.amountDue || "",
    });
    setData(singleList?.itemInfo);
    setDates(singleList?.paymentsDone);
    setTax(singleList?.taxDetails)
  }, [singleList, companyProfileData]);
  
  useEffect(() => {
    if (singleViewId !== null || vendorid !== null) {
      setPath(true)
    }
    else{
      setPath(false)
    }
    //console.log(singleViewId);
  }, []);
 
  return (
    <div className="main-container" style={{ backgroundColor: "unset", padding: "0" }}>
      {path && (
       <div className="first-main-container-div">
        <div className="first-main-heading-div" id="headingDiv">
          <p
            style={{
              marginLeft: "14px",borderRight:"2px solid #abaebb",
              color: selectedHeading === "Vendor Bill" ?"black" : "gray",
            }}
            onClick={() => {changeColor("Vendor Bill");handleBackpage()}}
          >
            Purchase Order
          </p>
          <p
            style={{borderRight:"2px solid #abaebb",
              color: selectedHeading === "purchase" ?  "black" : "gray",
            }}
            onClick={() => {changeColor("purchase");handleEdit()}}
          >
          {head}
          </p>
          <p
            style={{borderRight:"2px solid #abaebb",
              color: selectedHeading === "Single View" ? "black" : "gray",
            }}
           // onClick={() => changeColor("purchase Order GRN")}
          >
         {formValues?.name}
          </p>
        </div>
        </div>
      )}
      <div className="first-div-container"  style={{ backgroundColor: "white", justifyContent: "space-between" }}>
        {/* <div className="post-ribbon">
          {formValues?.status === "DRAFT" && <img src={Draft} alt="" />}
          {formValues?.status === "COMPLETED" && (
            <img src={postRibbon} alt="" />
          )}
        </div> */}
        <div style={{display:"flex",gap:"8px"}}>
        
        <Tooltip title="Edit">
          <IconButton>
            <i
              class="bi bi-pencil-square edit-icon1"
              onClick={() =>
                navigateTo("/userdashboard/accounts/vendor/createvendorBills")
              }
            ></i>
          </IconButton>
        </Tooltip>
        <span
          
          style={{ fontSize: "medium", color: "black", cursor: "pointer",alignContent:"center" }}
          onClick={() => {
            localStorage.removeItem("singleViewById");

            navigateTo("/userdashboard/accounts/vendor/vendorBills");
            // dispatch(set_Back_button_action({ backButtonClickAction: true }));
          }}
        > Vendor Bill &gt;</span>
        <span style={{fontSize:"medium",alignContent:"center",paddingLeft:"8px"}}>{formValues?.name}</span>
        </div>
        <div>
        {/* <ReactToPrint
          trigger={() => (
            <IconButton className="printer-div">
              <i style={{ color: "black" }} class="bi bi-printer"></i>
            </IconButton>
          )}
          content={() => paymentsPrint}
        /> */}
         <Tooltip title="Share">
          <IconButton>
            <i class="bi bi-share" style={{ backgroundColor: "#9797e9", color: "white", fontSize: "medium", padding: "8px", borderRadius: "2px" }}></i>
          </IconButton>
        </Tooltip>

        {/* <ReactToPrint
          trigger={() => (
            <IconButton className="printer-div" style={{ padding: "1px" }}>
              <i style={{ color: "white", backgroundColor: " #d787e7", fontSize: "medium", padding: "8px", borderRadius: "2px" }} class="bi bi-printer"></i>
            </IconButton>
          )}
          content={() => paymentsPrintNew}
        /> */}
        <ReactToPrint
            // The print button
            trigger={() => (
              <IconButton className="printer-div" style={{ padding: "1px" }}>
                <i
                  style={{
                    color: "white",
                    backgroundColor: " #d787e7",
                    fontSize: "medium",
                    padding: "8px",
                    borderRadius: "2px",
                  }}
                  class="bi bi-printer"
                ></i>
              </IconButton>
            )}
            // The content to be printed (standalone component)
            content={() => printRef.current}
            // Set the page style for printing
            pageStyle="@page { size: A4; margin: 10mm }"
          />

        <Tooltip title="Download">
          <IconButton>
            <i class="bi bi-arrow-down-circle" style={{ backgroundColor: "rgb(255 118 133 / 69%)", color: "white", fontSize: "medium", padding: "8px", borderRadius: "2px" }}></i>
          </IconButton>
        </Tooltip>
        </div>
      </div>
      {/* <hr className="line" /> */}
      <div style={{ backgroundColor: "white", height: "80vh", marginTop: "4px", position: "relative" }}>

      <div className="second-main-container">
      <div className="post-ribbon"  style={{ right: "0px", top: "0px" }}>
          {formValues?.status === "DRAFT" && <img src={Draft} alt="" />}
          {formValues?.status === "COMPLETED" && (
            <img src={postRibbon} alt="" />
          )}
        </div>
        <div className="left-side-div">
          <img src={formValues?.companyLogo} alt={formValues?.companyName} />
          <p>{formValues?.companyAddress}</p>
          <p>{formValues?.companyContact}</p>

          <h1 className="vendor-head">Vendor Address</h1>
             <p style={{margin:"0" }}>{formValues?.customerName}</p>
             <p style={{margin:"0"}}>{formValues?.customerAddress}</p>
             <p style={{ fontWeight: "100",margin:"0" }}>{formValues?.customerContact}</p>
          {/* <p>--</p>
          <p>--</p> */}
        </div>
        <div className="right-side-div">
          <h1> Vendor Bill</h1>
          <p>{formValues?.name}</p>
          <div className="date-div">
            <p>
              {" "}
              <span class="date-container-single">Date:</span>
              {formValues?.expiry}
            </p>
            {/* <p>Order Date:{formValues?.secondDate} </p> */}
          </div>
        </div>
      </div>

      <div className="Table-container">
        <div className="Table-data">
          <table>
            <thead>
              <tr style={{ backgroundColor: "#eaeef9" }}>
                <th>No</th>
                <th>Product</th>
                <th>Account</th>
                <th>UOM</th>
                <th>QTY</th>
                <th>Unit Price</th>
                <th>Discount</th>
                <th>Tax</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#f1f2f5" : "white",
                  }}
                >
                  <td>{index + 1}</td>
                  <td>{item?.product}</td>
                  <td>{item?.accountName}</td>
                  <td>{item?.purchaseUomName}</td>
                  <td>{item?.recievedQuantity || item?.qty}</td>
                  <td>{item?.unitPrice}</td>
                  <td>{item?.discount}</td>
                  <td
                    style={{
                      display: "flex",
                      placeContent: "center",
                      marginTop: "10px",
                    }}
                  >
                    {item.taxIdList?.map((r, i) => (
                      <p key={i} style={{ margin: "1px" }}>
                        {r?.taxName}
                      </p>
                    ))}
                  </td>
                  <td>{item?.lineTotal?.toFixed(decimalPosition)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="last-total-div">
            <div className="sub-total">
              <h1>Total</h1>
              {dates?.map((date,index)=>(
              <p key={index}>{date.name}</p>
              ))}
              <h1>Amount Due</h1>
            </div>
            <div className="sub-total-amount">

              <h1>{formValues?.total}</h1>
              {dates?.map((date,index)=>(
              <p key={index}>{date.totalAmount}</p>
              ))}
              <h1>{formValues?.amountDue}</h1>
            </div>
          </div>
        </div>
      </div>
      </div>

      {/* payments print view */}
      <div style={{ display: "none" }}>
        <div ref={(el) => (paymentsPrint = el)}>
          <div className="print-view-top-container">
            <div
              className="print-view-top-left-container"
              style={{ width: "25%" }}
            >
              <p></p>
              <p></p>
            </div>
            <div
              className="print-view-top-middle-container"
              style={{ width: "50%" }}
            >
              {/* <h3>--</h3>

              <h3>--</h3> */}

              <p>Vendor Bill</p>
            </div>

            <div
              className="print-view-top-right-container"
              style={{ width: "25%" }}
            >
              <p>{convertDateFormat(today)}</p>
              <p>{""}</p>
            </div>
          </div>

          <div className="second-main-container">
            <div className="left-side-div">
              <img
                src={formValues?.companyLogo}
                alt={formValues?.companyName}
              />
              <p>{formValues?.companyAddress}</p>
              <p>{formValues?.companyContact}</p>

              <h1 className="vendor-head">Vendor Address</h1>
              <p>{formValues?.vendorName}</p>
              {/* <p>--</p>
              <p>--</p> */}
            </div>
            <div className="right-side-div">
              <h1>Vendor Bill </h1>
              <p>{formValues?.name}</p>
              <div className="date-div">
                <p>
                  {" "}
                  <span class="date-container-single">Date:</span>
                  {formValues?.firstDate}
                </p>
                {/* <p>Order Date:{formValues?.secondDate} </p> */}
              </div>
            </div>
          </div>

          <div className="Table-container" style={{ padding: "0px 35px" }}>
            <div className="Table-datas">
              <table style={{ overflow: "none" }}>
                <thead>
                  <tr style={{ backgroundColor: "#eaeef9" }}>
                    <th>No</th>
                    <th>Product</th>
                    <th>Account</th>
                    <th>UOM</th>
                    <th>QTY</th>
                    <th>Unit Price</th>
                    <th>Discount</th>
                    <th>Tax</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#f1f2f5" : "white",
                      }}
                    >
                      <td>{index + 1}</td>
                      <td>{item.label}</td>
                      <td>{item.accountName}</td>
                      <td>{item.purchaseUomName}</td>
                      <td>{item.qty}</td>
                      <td>{item.unitPrice}</td>
                      <td>{item.discount}</td>
                      <td
                        style={{
                          display: "flex",
                          placeContent: "center",
                          marginTop: "10px",
                        }}
                      >
                        {item.taxIdList?.map((r, i) => (
                          <p key={i}  style={{ margin: "1px" }}>
                            {r?.taxName}
                          </p>
                        ))}
                      </td>
                      <td>{item.subTotal}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="last-total-div">
            <div className="sub-total">
              {/* <h1>Sub Total</h1>
            <p>Discount(2.00%)</p>
            <p>standard Rate(2.00%)</p>
            <hr className='line-2' /> */}
              <h1>Total</h1>
              {dates?.map((date,index)=>(
              <p key={index}>{date.name}</p>
              ))}
              <h1>Amount Due</h1>
            </div>
            <div className="sub-total-amount">
              {/* <h1>$124,754.00</h1>
            <p>4000</p>
            <p>5000</p>
            <hr className='line-3' /> */}
              <h1>{formValues?.total}</h1>
              {dates?.map((date,index)=>(
              <p key={index}>{date.totalAmount}</p>
              ))}
              <h1>{formValues?.amountDue}</h1>
            </div>
          </div>
            </div>
          </div>
          <div className="terms">
            <h1>Terms & Conditions</h1>
          <hr className="lines" />
          </div>
        </div>
      </div>
      {/* Standalone print content - positioned off-screen but visible to ReactToPrint */}
      <div style={{ position: "absolute", left: "-9999px", top: "-9999px", width: "210mm" }}>
        <VendorBillPrintContent
          ref={printRef}
          formValues={formValues}
          data={data}
          tax={tax}
          dates={dates}
        />
      </div>
    </div>
  );
};
